import { Site } from '@snapchat/mw-common';
import { BackgroundType, CookieModal as CookiePopupGlobal } from '@snapchat/mw-global-components';
import { BackgroundColor } from '@snapchat/snap-design-system-marketing';
import type React from 'react';
import { useContext } from 'react';

import { AppContext } from '../../AppContext';
import { Config } from '../../config';
import {
  logError,
  onMarketingTrackingAccepted,
  onPerformanceTrackingAccepted,
} from '../../helpers/logging';
import { handlePartnerstackQueryParam } from '../../sites/for-business/utils/handlePartnerstackQueryParam';
import { setPersonasCookie } from '../../utils/personas/personasUtils';

export interface CookiePopupProps {
  isClient: boolean;
  backgroundColor?: BackgroundColor;
  globalPrivacyControl?: boolean;
}

const defaultBackgroundColor = BackgroundColor.White;

// TODO: Grab isClient from Config, grab globalPrivacyControl from AppContext,
// grab backgroundColor from Config.theme.
export const CookiePopup: React.FC<CookiePopupProps> = ({
  isClient,
  backgroundColor = defaultBackgroundColor,
  globalPrivacyControl,
}) => {
  const { cookieManager, personas } = useContext(AppContext);

  // Return nothing for SSR
  if (!isClient) return null;

  const backgroundType =
    backgroundColor === BackgroundColor.Black ? BackgroundType.DarkMode : BackgroundType.LightMode;

  // For non-production environments (localhost, staging sites) - specify empty string so that cookies will can be set.
  const cookieDomain =
    !Config.isDeploymentTypeProd || !Config.isCompilationModeProd ? '' : undefined;

  return (
    <CookiePopupGlobal
      cookieDomain={cookieDomain}
      backgroundType={backgroundType}
      onComplete={event => {
        if (event.cookieAcceptance.Marketing) {
          onMarketingTrackingAccepted().catch(error =>
            logError({ component: 'CookiePopup', error })
          );
        }

        if (event.cookieAcceptance.Performance) {
          onPerformanceTrackingAccepted().catch(error =>
            logError({ component: 'CookiePopup', error })
          );
        }

        if (event.cookieAcceptance.Preferences) {
          setPersonasCookie(cookieManager, personas);
        }

        // Special Logic for FOR BIZ Only to handle partner stack query params
        if (Config.site === Site.FOR_BUSINESS) {
          handlePartnerstackQueryParam?.(cookieManager, !!event.cookieAcceptance.Marketing);
        }
      }}
      globalPrivacyControl={globalPrivacyControl}
    />
  );
};
